export default __webpack_public_path__ + "static/media/1.cef65e53.jpg";